export const HEADER_MOBILE_PX = '64px';
export const HEADER_DESKTOP_PX = '72px'
export const DRAWER_WIDTH = 280;
